import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
        {children}
    </motion.div>
);

export const ChapterLabel = ({ number, title, testId }) => (
    <div className="flex items-center gap-4" data-testid={testId}>
        <span className="font-serif italic text-gold text-lg">{number}</span>
        <span className="h-px w-12 bg-gold/40" />
        <span className="text-[11px] font-semibold uppercase tracking-[0.35em] text-muted">
            {title}
        </span>
    </div>
);

export const ArrowButton = ({
    href,
    children,
    variant = "primary",
    testId,
    className = "",
}) => {
    const base =
        "group inline-flex items-center justify-center gap-3 rounded-sm px-8 py-4 text-[11px] font-bold uppercase tracking-[0.25em] transition-colors duration-300";
    const styles =
        variant === "primary"
            ? "bg-gold text-ink hover:bg-gold-soft"
            : "border border-white/25 text-ivory hover:border-gold hover:text-gold bg-transparent";
    return (
        <a
            data-testid={testId}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Opens WhatsApp"
            className={`${base} ${styles} ${className}`}
        >
            {children}
            <span className="inline-block transition-transform duration-300 group-hover:translate-x-1">
                →
            </span>
        </a>
    );
};
